module.exports = __webpack_public_path__ + "img/1539916655.6022db2c.jpg";